module.exports = __webpack_public_path__ + "img/belgium.a7be0e35.svg";